import { render, staticRenderFns } from "./MyModulePreview.vue?vue&type=template&id=389a20a2&scoped=true"
import script from "./MyModulePreview.vue?vue&type=script&lang=js"
export * from "./MyModulePreview.vue?vue&type=script&lang=js"
import style0 from "./MyModulePreview.vue?vue&type=style&index=0&id=389a20a2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a20a2",
  null
  
)

export default component.exports